import { render } from "./blog-only-heading.vue?vue&type=template&id=0660f4f2&scoped=true"
import script from "./blog-only-heading.vue?vue&type=script&lang=js"
export * from "./blog-only-heading.vue?vue&type=script&lang=js"

import "./blog-only-heading.vue?vue&type=style&index=0&id=0660f4f2&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0660f4f2"]])

export default __exports__